import { useFootnoteContext } from "@utils/FootnoteContext";
import cx from "classnames";

export const FootnoteList = ({ variant }: { variant?: string | null }) => {
  const { footnotes } = useFootnoteContext();
  if (footnotes.length === 0) return null;

  return (
    <section className={cx('py-10', variant === 'dark' ? '' : 'container-base')}>
      <ol className="flex flex-col gap-2">
        {footnotes.map(({ number, value }) => (
          <li key={number} className={cx('flex gap-2 text-body-small', variant === 'dark' ? 'text-brand-black/50' : 'text-neutral-light/60')}>
            <span className="shrink-0">{number}.</span>
            <span>{value}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};
